import React, { useState } from "react";
import styles from './EvaluationForm.module.scss';
import Icon from "../icon/Icon";
import AutoCompleteInstructor from "../autoCompleteInstructor/AutoCompleteInstructor";
import Button from "../button/Button";
import PropTypes from "prop-types";
import "../../styles/datepicker.scss";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import { format } from 'date-fns';
import CustomDatePicker from "../customDatePicker/CustomDatePicker";

const EvaluationForm = ({
  instructorList,
  onCancel,
  onSubmit,
  isLoading
}) => {
  const [instructor, setInstructor] = useState(null);
  const [instructorError, setInstructorError] = useState('');
  const [evaluationDate, setEvaluatioDate] = useState(null);
  const [evaluatioDateError, setEvaluatioDateError] = useState('');

  const validateInstructor = () => {
    if(!instructor) {
      return 'Instructor is required';
    }
    return '';
  };

  const validateEvaluatioDate = () => {
    console.log(evaluationDate);
    if(!evaluationDate) {
      return 'Evaluation Date is required';
    }
    return '';
  };

  const hanldeSubmit = () => {
    const instructorValidationResult = validateInstructor();
    const evaluationDateValidationResult = validateEvaluatioDate();

    setInstructorError(instructorValidationResult);
    setEvaluatioDateError(evaluationDateValidationResult);

    if (instructorValidationResult || evaluationDateValidationResult) {
      return false;
    }

    onSubmit({
      instructorId: instructor.instructorId,
      clinicalSiteId: instructor.clinicalSiteId,
      evaluationDate: format(evaluationDate, "yyyy-MM-dd")
    });
  };

  return (
    <form 
      className={styles.form}
      onSubmit={(e) => {
        e.preventDefault();
        hanldeSubmit();
      }}
    >
      {isLoading && <LoadingOverlay />}
      <div className={styles.header}>
        <span><Icon name="clipboard" /></span>
        <h3>Create Evaluation Request</h3>
      </div>
      <div className={styles.inputContainer}>
        <span className={styles.icon}><Icon name="users" /></span>
        <div className={styles.input}>
          <AutoCompleteInstructor
            label="Choose your Instructor"
            list={instructorList}
            onChange={(instructor) => setInstructor(instructor)}
            error={instructorError}
          />
        </div>
      </div>
      <div className={styles.inputContainer}>
        <span className={styles.icon}><Icon name="clock" /></span>
        <CustomDatePicker
          label="Evaluation Date"
          date={evaluationDate}
          onChange={(evaluationDate) => setEvaluatioDate(evaluationDate)}
          error={evaluatioDateError}
          minDate={new Date()}
        />
      </div>
      <div className={styles.actions}>
        <Button
          label="Cancel"
          variant="secondary"
          size="medium"
          onClick={onCancel}
        />
        <Button
          label="Send Request"
          variant="primary" 
          size="medium"
          type="submit"
        />
      </div>
    </form>
  );
};

EvaluationForm.propTypes = {
  instructorList: PropTypes.arrayOf(
    PropTypes.shape({
      instructorId: PropTypes.number.isRequired,
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      profilePicture: PropTypes.string,
      clinicalSiteId: PropTypes.number.isRequired,
      clinicalSite: PropTypes.string.isRequired,
      speciality: PropTypes.string
    })
  ).isRequired,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  isLoading: PropTypes.bool
}

export default EvaluationForm;